import React, {Fragment, useEffect, useState, useRef} from 'react';
import {Card, Loader, Accordion, Section, Date_picker, Text, Select, TextEditor, Form, HtmlTooltip, MultipleSelect} from '../../../../components';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import TitleIcon from '@material-ui/icons/List';
import EmailIcon from '@material-ui/icons/Email';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import Grid from '@material-ui/core/Grid';
import {connect} from 'react-redux';
import TuneIcon from '@material-ui/icons/Tune';
import Condition_section from './Conditions';
import Tooltip from '@material-ui/core/Tooltip';
import FactCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import MenuIcon from '@material-ui/icons/Menu'
import {useTheme} from "@material-ui/core";


function Checklists(props){
  let step_fields=useRef(undefined);
  const[new_index,setNewIndex]=useState(0);
  const[error, setError]=useState(false);
  const[preview_popup,setPreviewPopup]=useState(undefined);
  const theme=useTheme();
  let first_time_template=useRef(true);
  let first_time_sequence=useRef(true);

  function onSubmit(params){
    console.log(params, 'PARAMS');
    if(params.checklist_steps!=undefined){
      let checklist_steps=[];
      for(let cs of params.checklist_steps){
        if(cs.option_conditional==false && cs.checklist_step_conditions!=undefined){delete cs.checklist_step_conditions;}
        checklist_steps.push(cs);
      }
      params.checklist_steps=checklist_steps;
    }
    if(props.match.params.id==undefined){props.createChecklist(params);}
    else{props.updateChecklist(props.match.params.id, params);}
  }

  function moveCard(dragIndex, hoverIndex){
    let min_index=(dragIndex<=hoverIndex)?dragIndex:hoverIndex;
    let max_index=(hoverIndex>=dragIndex)?hoverIndex:dragIndex
    let new_fields=[];
    let index=0;
    for(let f of step_fields.current.input.value){
      if(index==min_index){new_fields.push(step_fields.current.input.value[max_index]);}
      if(index!=max_index){new_fields.push(f);}
      index+=1;
    }
    step_fields.current.input.onChange(JSON.parse(JSON.stringify(new_fields)));
  }

  useEffect(()=>{
    if(props.short_codes==undefined){props.indexShortCodes();}
    if(props.queues==undefined){props.indexQueues();}
    if(props.match.params.id!=undefined && (props.checklists==undefined || props.checklists[props.match.params.id]==undefined)){props.getChecklist(props.match.params.id);}
    if(props.documents_index!=true){props.indexDocuments();}
  },[]);

  let initial_values={}; if(props.match.params.id!=undefined && props.checklists!=undefined && props.checklists[props.match.params.id]!=undefined){initial_values=props.checklists[props.match.params.id]; let ivs=[]; for(let s of initial_values.checklist_steps){s.document_ids=[]; if(s.documents!=undefined){for(let d of s.documents){s.document_ids.push(d.id);}} if(s.task_queue_id!=undefined){s.auto_follow_up_check=true;} if(s.checklist_step_conditions.length>0){s.option_conditional=true;} ivs.push(s);} initial_values.checklist_steps=ivs}
  let select_templates=[];

  let queues=[];
  if(props.queues!=undefined){for(let key in props.queues){queues.push(props.queues[key]);}}


  let template_list=[];
  let sequence_list=[];
  if(props.templates_index==true){for(let t_key in props.templates){let xy=props.templates[t_key]; let name=xy.name; if(xy.sent_count>10){if(xy.open_count==0){name=name+'       (0.0%)'}else{name=name+' ('+(xy.open_count/(xy.sent_count/100)).toFixed(1)+'%)'}} template_list.push({id:t_key, name:name});}}else if(first_time_template.current==true){props.getTemplates(); first_time_template.current=false;}
  if(props.sequences!=undefined && props.templates_index==true){for(let s_key in props.sequences){sequence_list.push({id:s_key, name:props.sequences[s_key].name});}}else if(first_time_sequence.current==true){props.getSequences(); first_time_sequence.current=false;}

  let owners=[{id:'CURRENT', name:'User who completes the checklist'}, {id:'COMPANY', name:'Owner of the specific company'}];
  if(props.workspace!=undefined){let us=props.workspace.user_workspaces; for(let key in us){owners.push({id:us[key].id, name:us[key].first_name+' '+us[key].last_name})}}
  let documents_select=[]; if(props.documents!=undefined){for(let key in props.documents){documents_select.push(props.documents[key]);}}
  return(
    <Fragment>
    <Section title={(props.match.params.id!=undefined)?"Edit checklist":'New checklist'} icon={<TitleIcon color='primary'/>} action={<Button variant='contained' onClick={()=>{props.history.push('/sales_coach/checklists')}}>Exit</Button>}>
      <Form
        onSubmit={onSubmit}
        mutators={{
          ...arrayMutators
        }}
        fields_depending_on_others={{
            checklist_step_conditions:'option_conditional'
        }}
        initialValues={initial_values}
        handleClose={()=>{props.history.push('/sales_coach/checklists')}}
        errorTrigger={()=>{setError(true);}}
        loader
      >
        {form_props => (
          <form onSubmit={form_props.handleSubmit}>
            <div style={{maxWidth:'400px', width:'100%'}}><Text required title='Name' name='name'/></div>
            <div style={{maxWidth:'400px', width:'100%'}}><Text required title='Description' name='description' rows={3}/></div>
            {(error==false)?null:<div style={{ width:'calc(100% - 30px)', marginLeft:'10px', marginTop:'20px', marginBottom:'20px', padding: '16px', backgroundColor:theme.palette.professional_red.transparent, borderRadius: '8px', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'}} > <Typography variant='caption' color='error'>You must fill in all required fields before submitting. Make sure checklist steps which should include tasks have a queue defined.</Typography></div>}
            <Field name='checklist_steps'>{(f)=>{step_fields.current=f; return null}}</Field>
            <FieldArray name='checklist_steps'>
            {({ fields }) =>
              <Fragment>
              <Typography color='primary' style={{marginTop:'30px', marginBottom:'30px'}}><span><FactCheckIcon color='primary' style={{position:'absolute', left:'20px'}}/></span><span style={{marginLeft:'40px'}}>Checklist steps</span><AddIcon color='secondary' style={{position:'absolute', right:'20px', cursor:'pointer'}} onClick={()=>{fields.push({internal_id:'js_'+new_index, type:3, text:'Default name', auto_follow_up_check:false, due_date:3, priority:1, task_user_workspace_id:'CURRENT', contacts_visible_conditions:0, contacts_autoclick_conditions:0}, undefined); setNewIndex(new_index+1)}}/></Typography>
              {fields.map((name, index) => {
                let card=fields.value[index];
                return(
                  <Card
                    key={(card.id==undefined)?card.internal_id:card.id}
                    index={index}
                    id={(card.id==undefined)?card.internal_id:card.id}
                    moveCard={moveCard}
                    text={
                      <Fragment>
                        <hr style={{width:'100%', marginTop:'0px', marginBottom:'0px'}}/>
                        
                        <Accordion  content={[{title:
                          <Typography style={{marginLeft:'10px', marginBottom:'0px', position:'relative', width:'calc(100% - 20px)'}} color='primary' ><MenuIcon style={{position:'absolute', left:'-25px', cursor:'move', top:'3px', fontSize:'15px'}}/><Field name={`${name}.text`}>{(f)=><Field name={`${name}.explanation`}>{(ff)=><HtmlTooltip title={ff.input.value}><span style={{maxWidth:'calc(100% - 50px)', overflow:'hidden'}}>{(index+1)+')  '}<span style={{color:'rgba(0, 0, 0, 0.87)'}}>{f.input.value}</span></span></HtmlTooltip>}</Field>}</Field><DeleteIcon color='secondary' style={{position:'absolute', right:'-10px', top:'0px', cursor:'pointer'}} onClick={(e)=>{let new_fields=[]; let i=0; for(let sf of step_fields.current.input.value){if(i!=index){new_fields.push(sf);}; i+=1;}; step_fields.current.input.onChange([]); window.setTimeout(function(){step_fields.current.input.onChange(new_fields);}, 10); e.stopPropagation()}}/></Typography>
                        ,
                        content:
                          <Grid container style={{marginBottom:'20px'}}>
                          <Grid item xs={12} sm={5}>
                          <Grid container>
                            <Grid item xs={12} style={{marginBottom:'10px'}}><Text required  multiline rows={2} title='Text' name={`${name}.text`}/></Grid>
                            <Grid item xs={12} style={{marginBottom:'10px'}}><Select required title='Type' name={`${name}.type`} select_data={[{id:2, name:'Phone call'}, {id:4, name:'Cold call task'}, {id:6, name:'Send message'}, {id:0, name:'Send email'}, {id:1, name:'Data entry & research'}, {id:3, name:'Step without a task'}, {id:5, name:'Warning: alert'}]}/></Grid>
                            <Grid item xs={12} style={{marginBottom:'10px'}}><Field name={`${name}.document_ids`}>{(f)=><MultipleSelect title='Documents' select_data={documents_select} value={f.input.value} onChange={f.input.onChange} with_id/>}</Field></Grid>
                            <Grid item xs={12}><Field name={`${name}.option_conditional`}>{(f)=>{return(<FormControlLabel control={<Checkbox style={{marginLeft:'10px'}} checked={f.input.value} onChange={f.input.onChange} name="option_conditional" color="primary"/>} label="Make conditional"/>)}}</Field></Grid>
                            <Grid item xs={12}><Field name={`${name}.type`}>{(f_type)=><Field name={`${name}.auto_follow_up_check`}>{(f)=>{console.log(f_type.input.value, 'FTYPE'); let task_step=false; let block=false;// if(card.id!=undefined){for(let x of initial_values.checklist_steps){if(x.id==card.id && x.type==f_type.input.value && f.input.value==false){block=true;}}}
                            if(block==false && [0,1,2,4,6].includes(f_type.input.value)){task_step=true; if(f.input.value==false){f.input.onChange(true);}}else if(f_type.input.value==3){console.log('TWO', f.input.value); task_step=true; if(f.input.value==true){f.input.onChange(false);}} return(<FormControlLabel control={<Checkbox style={{marginLeft:'10px'}} disabled={task_step} checked={f.input.value} onChange={f.input.onChange} name="auto_follow_up_check" color="primary"/>} label="Is task"/>)}}</Field>}</Field></Grid>
                          </Grid>
                          </Grid>
                          <Grid item xs={12} sm={7}>
                           <Grid container>
                           <Grid item xs={12}><Field name={`${name}.option_conditional`}>{(ff)=><Field name={`${name}.auto_follow_up_check`}>{(f)=>{
                             return(<Fragment>{(f.input.value==true)?
                             <Grid container>
                                <Grid item xs={12} sm={6} style={{marginBottom:'15px'}}><Text title='Due date (in x days)' required name={`${name}.due_date`} numeric/></Grid>
                                <Grid item xs={12} sm={6} style={{marginBottom:'10px'}}><Select title='Priority' name={`${name}.priority`} select_data={[{id:0, name:'High'}, {id:1, name:'Medium'}, {id:3, name:'Low'}]}/></Grid>
                               {(1==1)?null:<Grid item xs={12}style={{marginBottom:'15px'}}><Select title='Follow up with' required name={`${name}.checklist_step_task.follow_up_with`} select_data={[{id:0, name:'Task'}, {id:1, name:'Email template'}, {id:2, name:'Email sequence'}]}/></Grid>}
                               <Field name={`${name}.follow_up_with`}>{(f)=>(f.input.value==0)?<Fragment>
                                 <Grid item xs={12} sm={6} style={{marginBottom:'15px'}}><Select title='Queue' required name={`${name}.task_queue_id`} select_data={queues}/></Grid>
                                 <Field name={`${name}.task_queue_id`}>{(f)=>(f.input.value=='new')?<Grid item xs={12} sm={6} style={{marginBottom:'15px'}}><Text required title='Queue name' name={`${name}.task_queue_name`}/></Grid>:null}</Field>
                                 <Grid item xs={12} sm={6} style={{marginBottom:'15px'}}><Select title='Task owner' required name={`${name}.task_user_workspace_id`} select_data={owners}/></Grid>
                                 </Fragment>
                                 :(f.input.value==1)?<Fragment>
                                    <Grid item xs={12} sm={6} style={{marginTop:'10px'}}><Select title='Template' required name={`${name}.template_id`} select_data={template_list} style={{maginBottom:'5px', marginTop:'0px'}}/></Grid>
                                    <Grid item xs={12} style={{marginTop:'5px'}}><Field name={`${name}.template_id`}>{(f)=><Fragment><TemplateNotes {...props} setPreviewPopup={setPreviewPopup} template_id={(f.input.value=='')?undefined:f.input.value}/><Placeholders {...props} template_id={(f.input.value=='')?undefined:f.input.value}/></Fragment>}</Field></Grid>
                                 </Fragment>
                                 :(f.input.value==2)?<Fragment>
                                   <Grid item xs={12} sm={6} style={{marginTop:'10px'}}><Select title='Sequence' required name={`${name}.sequence_id`} select_data={sequence_list} style={{marginTop:'0px'}}/></Grid>
                                   <Field name={`${name}.sequence_id`}>{(f)=>{return(<Fragment>{(f.input.value!=undefined && props.sequences[Number(f.input.value)]!=undefined)?<Grid item xs={12} style={{marginTop:'10px'}}>{props.sequences[Number(f.input.value)].sequence_emails.map(function(se, index){
                                     let html_template=props.templates[se.html_template_id];
                                     let wait_types=['seconds','minutes','hours','days','weeks','months'];
                                     return(<div><Typography style={{marginLeft:'10px'}} variant='caption'><span style={{fontWeight:'bold'}}>{'Wait '+se.wait+' '+wait_types[se.type]+': '}</span><span>{html_template.name}</span><Typography variant='caption' style={{textDecoration:'underline', cursor:'pointer', marginLeft:'20px'}} onClick={()=>{setPreviewPopup(html_template);}} color="primary">(preview)</Typography></Typography></div>)
                                   })}</Grid>:null}</Fragment>)}}</Field>
                                   <Grid item xs={12} style={{marginTop:'5px'}}><Field name={`${name}.sequence_id`}>{(f)=><Placeholders {...props} sequence_id={(f.input.value=='')?undefined:f.input.value}/>}</Field></Grid>
                                  </Fragment>:null}</Field>
                             </Grid>:null}
                             {(ff.input.value==true)?
                             <Condition_section {...props} namespace={`${name}.checklist_step_conditions`} name_prefix={name}/>
                             :null}</Fragment>)}
                           }</Field>}</Field></Grid>
                           </Grid>
                          </Grid>
                          <Grid item xs={12} style={{marginBottom:'5px'}}><Field name={`${name}.explanation`}>{(f)=><div style={{width:'calc(100%-30px)', marginLeft:'10px', marginTop:'10px', marginBottom:'10px'}}><TextEditor block_short_codes={true} title='Explanation' required index={index} value={f.input.value} onChange={f.input.onChange}/></div>}</Field></Grid>
                          </Grid>
                        }]}/>
                      </Fragment>
                    }/>
              )})}
              <div style={{marginTop:'30px', width:'100%', position:'relative', display:'flex', justifyContent:'center', alignItems:'center'}}><Button color='primary' variant='contained' onClick={()=>{form_props.form.submit();}}>Save</Button></div>
              </Fragment>
            }</FieldArray>
          </form>
        )}
      </Form>
    </Section>
    <div style={{height:'30px'}}/>
    </Fragment>
  );
}



function TemplateNotes(props){
  let template; if(props.templates!=undefined && props.template_id!=undefined){template=props.templates[props.template_id];}

  if(template==undefined){return null;}
  return(
    <div style={{width:'calc(100% - 10px)', marginLeft:'10px', marginTop:'10px'}}>
      <Typography color='primary' style={{width:'100%'}}><span>{"Notes  "}</span><Typography style={{fontStyle:'italic', cursor:'pointer', textDecoration:'underline'}} variant="caption" onClick={()=>{props.setPreviewPopup(template);}}>{"(preview "+template.name+")"}</Typography></Typography>
      <Typography variant='caption' style={{width:'100%'}}>{template.notes}</Typography>
    </div>
  )
}


function Placeholders(props){
  let placeholders=[];
  let template_ids;
  let plus_ss=useRef(undefined);

  if(props.template_id!=undefined && props.templates[props.template_id]!=undefined){template_ids=[props.template_id];}
  else if(props.sequence_id!=undefined){template_ids=[]; if(props.sequences[props.sequence_id]!=undefined){for(let s of props.sequences[props.sequence_id].sequence_emails){template_ids.push(s.html_template_id);}}}
  if(template_ids!=undefined){
    for(let template_id of template_ids){
      let template_html=props.templates[template_id].html;
      let array=template_html.match(/\$\{[^\}]*\}/g);
      if(array!=null){for(let ot of array){
        if(ot.toUpperCase()!='${FIRST_NAME}' && ot.toUpperCase()!='${LAST_NAME}' && ot.toUpperCase()!='${CITY}'){
          let nt=ot.replace('${', '').replace('}','').toLowerCase().replace('_',' ');
          nt=nt[0].toUpperCase() + nt.substring(1);
          if(!placeholders.includes(nt)){placeholders.push({name:nt, template_name:props.templates[template_id].name});}
      }}}
    }
  }
  if(props.sequence_id!=undefined && props.sequences[props.sequence_id]!=undefined){
    //  let plus_seconds=0; for(let se of props.sequences[props.sequence_id].sequence_emails){if(se.order==0){if(se.type==0){plus_seconds=se.wait;}else if(se.type==1){plus_seconds=(se.wait*60);}else if(se.type==2){plus_seconds=(se.wait*3600);}else if(se.type==3){plus_seconds=(se.wait*3600*24);}else if(se.type==4){plus_seconds=(se.wait*3600*24*7)}else if(se.type==5){plus_seconds=(se.wait*3600*24*30);}}}
    //  plus_seconds=plus_seconds*1000;
    //  if(plus_seconds!=plus_ss.current){
    //    plus_ss.current=plus_seconds;
    //    let now=new Date();
    //    let default_date=new Date(now.getTime() + plus_seconds);
    //    props.changeDefaultDate((plus_seconds==0)?undefined:default_date, props.updateDateTimeFunc);
      //}
  }
  if(placeholders.length==0){return <div style={{height:'80px'}}/>;}
  return(
    <Fragment>
    <Grid container style={{width:'100%'}}>
    <Grid item xs={12}><Typography color='primary' style={{marginLeft:'10px', marginTop:'10px', marginBottom:'5px'}}>Placeholders</Typography></Grid>
    {placeholders.map(function(p){
      return(<Grid item xs={12} sm={6}>
        <div style={{width:'calc(100% - 20px)', marginLeft:'10px'}}>
        <Typography><span>{p.name}</span>{(props.sequence_id!=undefined)?<Typography variant='caption' style={{fontStyle:'italic'}}>{" ("+p.template_name+")"}</Typography>:null}</Typography>
        <Field name={'placeholders.'+p.name.toLowerCase().replace(' ','_')}>{(f)=><TextEditor value={f.input.value} onChange={(e)=>{f.input.onChange(e)}}/>}</Field>
        </div>
        </Grid>)
    })}</Grid>
    </Fragment>
  )
}




export default connect(ss, dd)(Checklists);

function ss(state){
  return{
    queues:state.lists.queue_data,
    documents:state.sales_coach.documents,
    documents_index:state.sales_coach.documents_index,
    templates:state.templates.templates,
    sequences:state.templates.sequences,
    checklists:state.sales_coach.checklists,
    templates_index:state.templates.templates_index,
    short_codes:state.templates.short_codes
  }
}

function dd(dispatch){
  return{
    indexDocuments:()=>{dispatch({type:'REQUEST_INDEX_DOCUMENTS'});},
    indexQueues:()=>{dispatch({type:'REQUEST_QUEUE_INDEX'})},
    getTemplates:()=>{dispatch({type:'REQUEST_INDEX_HTML_TEMPLATES'})},
    getSequences:()=>{dispatch({type:'REQUEST_INDEX_EMAIL_SEQUENCES'})},
    getChecklist:(id)=>{dispatch({type:'REQUEST_GET_CHECKLIST', id:id})},
    createChecklist:(data)=>{dispatch({type:'REQUEST_CREATE_CHECKLIST', payload:data})},
    updateChecklist:(id, data)=>{dispatch({type:'REQUEST_UPDATE_CHECKLIST', id:id, payload:data})},
    indexShortCodes:()=>{dispatch({type:'REQUEST_INDEX_SHORT_CODES'});}
  }
}
